const variables = {
  screenWidth: '1000px',
  footerHeight: '15rem',
  footerHeightMobile: '10rem',
};

export default variables;
